import feathersClient, {makeServicePlugin, BaseModel} from '../../feathers-client'

class AgendaItem extends BaseModel {
    constructor(data, options) {
        super(data, options)
    }

    // Required for $FeathersVuex plugin to work after production transpile.
    static modelName = 'AgendaItem';

    // Define default properties here
    static instanceDefaults() {
        return {
            eventId: null,
            date_string: '',
            order: null,
            html_desc: '',
            html_desc_tc: '',
            html_desc_sc: '',
            html_content: '',
            html_content_tc: '',
            html_content_sc: '',
        }
    }
}

const servicePath = 'f-agenda-items';
const servicePlugin = makeServicePlugin({
    Model: AgendaItem,
    service: feathersClient.service(servicePath),
    servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
    before: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    after: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    },
    error: {
        all: [],
        find: [],
        get: [],
        create: [],
        update: [],
        patch: [],
        remove: []
    }
});

export default servicePlugin